import { attributesConditionsMatch } from 'shared-helpers/customAttributes';

import type { RequestUser, ServerConfig } from 'shared-types';

type ClientServerConfig = ServerConfig<'guest'> &
  Partial<ServerConfig<'user'>>;

const shouldShowUserConsentForm = (
  user: RequestUser,
  serverConfig: ClientServerConfig
) => {
  const requireTwoFactor = () =>
    !user.twoFactorAuthIsEnabled &&
    user.authenticatorType === 'local' &&
    user.id !== 1 &&
    ((user.roles.includes('admin') &&
      serverConfig?.authRequireTwoFactor === 'admins') ||
      (user.roles.includes('user') &&
        serverConfig?.authRequireTwoFactor === 'all')) &&
    attributesConditionsMatch({
      conditions: serverConfig?.authRequireTwoFactorConditions?.conditions,
      customAttributeValues: user.customAttributes,
      user
    });

  return (
    user &&
    user.roles.includes('user') &&
    !user.passwordForceChange &&
    (serverConfig.accountAskForConsent || serverConfig.accountAskForTerms) &&
    !user.consent?.value &&
    !user.consent?.valueIsEmployee &&
    !requireTwoFactor()
  );
};

export default shouldShowUserConsentForm;
